import { AxiosError, AxiosResponse } from "axios";
// import { IFixedAndMetaField } from 'common/FlexFieldsUtils';
import http from "../common/http-commons";
// import { IVendorListPayload, IVendorRequest, IVendorResponse } from 'models/vendor';
// import { CLIENT_SETUP_FORM, CLIENT_SETUP_FORM_FOR_ADMIN_USER } from 'screensLayoutData/client';

// import { IAPIKeysRequest, IAPIKeysResponse } from '../models';
import { IGetListRequest, IResponse, IServerError } from "../models/common";
// import { IReimbursementsListPayload, IReimbursementsRequest, IReimbursementsResponse } from '../models/reimbursements';
import { GridSize } from "@mui/material";
import { DataType, FieldType } from "@websential/cosmic-v20";
import {
	IReimbursements,
	IReimbursementsListPayload,
	IReimbursementsResponse,
} from "../models/Reimbursements";
// import { INITIAL_PAGE_SIZE } from 'common/constants';

export const ReimbursementsService = {
	getReimbursements: async (
		clientId: string,
		data: IGetListRequest,
		navigateToLogout: (path: string) => void
	): Promise<
		| IReimbursementsListPayload
		| IServerError
		| IResponse
		| IReimbursementsResponse[]
	> => {
		try {
			const response: AxiosResponse<IReimbursementsListPayload> =
				await http.get<IReimbursementsListPayload>(
					"/v1/reimbursement/?client_id=" +
						clientId +
						"&order_by=" +
						data.order_by +
						"&order_direction=" +
						data.order_direction +
						"&page=" +
						data.page +
						"&size=" +
						data.size +
						"&search_query=" +
						data.search_query
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	getById: async (
		clientId: string,
		id: string | undefined,
		navigateToLogout: (path: string) => void
	): Promise<IReimbursements | IServerError | IResponse | null | any> => {
		if (!id) return null;
		try {
			const response: AxiosResponse<IReimbursements> =
				await http.get<IReimbursements>(
					`/v1/reimbursement/${id}/?client_id=${clientId}`
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	create: async (
		requestPayload: any
	): Promise<IReimbursements | IServerError | IResponse | any> => {
		if (requestPayload.id) {
			
			try {
				const response: AxiosResponse<IReimbursements> =
					await http.put<IReimbursements>(
						`/v1/reimbursement/${requestPayload.id}/`,
						requestPayload
					);

				if (response.status === 200) {
					return response;
				} else if (response.status === 400) {
					return response.data;
				} else if (response.status === 500) {
					return {
						status: false,
						message: "Something went wrong.",
						error: true,
					};
				}
			} catch (error) {
				const axiosError = error as AxiosError;
				console.error("An error occurred:", axiosError);
				const errorMessage =
					axiosError.response && typeof axiosError.response.data === "string"
						? axiosError.response.data
						: "Unknown error";
				if (axiosError && axiosError.status === 401) {
					requestPayload.navigateToLogout("/logout");
					return {
						status: false,
						message: "UnAuthrized",
					};
				} else {
					return {
						status: false,
						message: errorMessage,
					};
				}
			}
		}

	
		try {
			const response: AxiosResponse<IReimbursements> =
				await http.post<IReimbursements>(`/v1/reimbursement/`, requestPayload);

		
			if (response.status === 201) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	delReimbursements: async (
		delPayload: any
	): Promise<string | IServerError | IResponse | any> => {
	
		// return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
		try {
			const response: AxiosResponse<string> = await http.delete<string>(
				`/v1/reimbursement/${delPayload.reimbursementsId}/`
			);

			if (response.status === 204) {
				return "Reimbursements has been deleted successfully";
			} else if (response.status === 200) {
				return "Reimbursements has been deleted successfully";
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				delPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	delBulkReimbursementses: async (
		requestPayload: any
	): Promise<string | IServerError | IResponse> => {
	
		try {
			const response = await http.delete<string>(`/v1/reimbursement/`, {
				data: requestPayload.reimbursementsIds,
			});
			if (response.status === 200) {
				return response.data;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
		
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	archiveReimbursements: async (
		archivePayload: any
	): Promise<string | IServerError | IResponse | any> => {
		
		// return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
		try {
			const response: AxiosResponse<string> = await http.post<string>(
				`/v1/reimbursements/${archivePayload.reimbursementsId}/`
			);

			if (response.status === 201) {
				return "Reimbursements has been archived successfully";
			} else if (response.status === 200) {
				return "Reimbursements has been archived successfully";
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				archivePayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	getReimbursementDDL: async (
		clientId: string
	): Promise<any | IServerError | IResponse | null> => {
		const response: AxiosResponse<any[]> = await http.get<any[]>(
			`/v1/reimbursement/reimbursement-ddl?client_id=${clientId}`
		);

		if (response.status === 200) {
			return response.data;
		}

		return {
			status: false,
			message: "Something went wrong please try again later.",
		};
	},
};
